export default "__VITE_ASSET__CjvkvuV8__"